import request from '@/config/axios'

export type VipPlan = {
  id: number
  type: number
  price: number
  recommended: number
}
export const getVipPlanList = () => {
  return request.get({
    url: '/vip-plan/list'
  })
}